// src/components/FeedbackLink.js
import React from 'react';
import { FEEDBACK_URL } from '../data/externalLinks';
import './FeedbackLink.css';

const FlagIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M4 15s1-1 4-1 5 2 8 2 4-1 4-1V3s-1 1-4 1-5-2-8-2-4 1-4 1z"></path>
    <line x1="4" y1="22" x2="4" y2="15"></line>
  </svg>
);

const ExternalIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <line x1="7" y1="17" x2="17" y2="7"></line>
    <polyline points="7 7 17 7 17 17"></polyline>
  </svg>
);

const FeedbackLink = ({ text }) => (
  <a
    href={FEEDBACK_URL}
    target="_blank"
    rel="noopener noreferrer"
    className="feedback-link"
  >
    <span className="feedback-link-icon" aria-hidden="true"><FlagIcon /></span>
    <span className="feedback-link-text">{text}</span>
    <span className="feedback-link-ext" aria-hidden="true"><ExternalIcon /></span>
  </a>
);

export default FeedbackLink;
